import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SuperComponent } from '../../../inside.super';
import { DownloadApiService } from '../../../../../generated/api/download/download.service';
import { DownloadCollection, DownloadEntity } from '../../../../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['../../../commonless/content.less',
        './downloads.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DownloadsComponent extends SuperComponent {

    downloads: DownloadCollection;

    private readonly downloadUrlPrefix = '/api/downloads';

    constructor(
        private readonly downloadApiService: DownloadApiService
    ) {
        super();

        this.downloadApiService.getDownloads().subscribe(downloads => {
            this.downloads = downloads;
        });
    }

    download(url: string) {
        window.open(url, '_blank').focus();
    }

    downloadEntity(entity: DownloadEntity) {
        const url = entity.url
            ? entity.url + entity.fileName
            : `${this.downloadUrlPrefix}/${entity.id}`;

        window.open(url, '_blank').focus();
    }

}
